document.addEventListener('DOMContentLoaded', () => {  

  const ukElements = document.querySelectorAll('.uk');
  const denmarkElements = document.querySelectorAll('.denmark');
  const netherlandsElements = document.querySelectorAll('.netherlands');
  const deutschlandElements = document.querySelectorAll('.deutschland');
  const switzerlandElements = document.querySelectorAll('.switzerland');
  const italyElements = document.querySelectorAll('.italy');
  const franceElements = document.querySelectorAll('.france');
  const polandElements = document.querySelectorAll('.poland');
  const usElements = document.querySelectorAll('.us');
  
  function handleHoverUk(event) {
    ukElements.forEach(element => {
        element.classList.toggle('active');
    });
  }
  function handleHoverDenmark(event) {
      denmarkElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverNetherlands(event) {
      netherlandsElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverDeutschland(event) {
      deutschlandElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverSwitzerland(event) {
      switzerlandElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverItaly(event) {
      italyElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverFrance(event) {
      franceElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverPoland(event) {
      polandElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  function handleHoverUS(event) {
      usElements.forEach(element => {
          element.classList.toggle('active');
      });
  }
  
  ukElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverUk);
      element.addEventListener('mouseleave', handleHoverUk);
  });
  denmarkElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverDenmark);
      element.addEventListener('mouseleave', handleHoverDenmark);
  });
  netherlandsElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverNetherlands);
      element.addEventListener('mouseleave', handleHoverNetherlands);
  });
  deutschlandElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverDeutschland);
      element.addEventListener('mouseleave', handleHoverDeutschland);
  });
  switzerlandElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverSwitzerland);
      element.addEventListener('mouseleave', handleHoverSwitzerland);
  });
  italyElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverItaly);
      element.addEventListener('mouseleave', handleHoverItaly);
  });
  franceElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverFrance);
      element.addEventListener('mouseleave', handleHoverFrance);
  });
  polandElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverPoland);
      element.addEventListener('mouseleave', handleHoverPoland);
  });
  usElements.forEach(element => {
      element.addEventListener('mouseenter', handleHoverUS);
      element.addEventListener('mouseleave', handleHoverUS);
  });

});